import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { IGlobalMetaSchema } from "@api/types/globalService.types";
import { URLSearchParamsInit } from "react-router-dom";
import { IPincodeReponseSchema } from "./pincodeType.api";

const getAllPincodesAPI = ({
  searchParams,
  signal,
}: {
  searchParams?: URLSearchParamsInit;
  signal?: AbortSignal;
}): Promise<{ data: IPincodeReponseSchema[]; meta: IGlobalMetaSchema }> =>
  handleGlobalGetRequestQuery({ url: URLS.PINCODES, searchParams, signal });

export { getAllPincodesAPI };
